import { computed } from 'vue';
import { useVuelidate } from '@vuelidate/core';

/**
 * Composable for form validation with Vuelidate
 * Provides common validation utilities and error message handling
 *
 * @param {Object} rules - Vuelidate validation rules
 * @param {Object} state - Reactive state to validate
 * @param {Function} getErrorMessage - Function to get error messages for fields
 * @returns {Object} Validation utilities
 */
export const useFormValidation = (rules, state, getErrorMessage) => {
  const v$ = useVuelidate(rules, state);

  const formErrors = computed(() => {
    const errors = {};
    Object.keys(rules.value || rules).forEach(field => {
      errors[field] = getErrorMessage(field);
    });
    return errors;
  });

  const isFormValid = computed(() => !v$.value.$invalid);

  const validateForm = async () => {
    return v$.value.$validate();
  };

  const touchField = field => {
    v$.value[field].$touch();
  };

  const resetValidation = () => {
    v$.value.$reset();
  };

  return {
    v$,
    formErrors,
    isFormValid,
    validateForm,
    touchField,
    resetValidation,
  };
};
